import FormApi from "../../services/api/formApi.js";
import productCategoryList from "../../data/_productCategoryList.json";
import { Dropbox } from "dropbox";

const FormApiService = new FormApi();

export default {
  data() {
    return {
      model: {
        fileUploaded: true,
        file: false,
        uploadedFileName: "",
        firstName: "",
        lastName: "",
        brandName: "",
        instagram: "",
        emailAddress: "",
        phoneNumber: "",
        website: "",
        productCategory: "",
        hearAboutBulletin: "",
        sellStores: "",
        productCategories: [],
      },
      requestStarted: false,
    };
  },

  methods: {
    onFileChange: onFileChange,
    removeFile: removeFile,
    submit: submit,
    resetForm: resetForm,
    dropboxUpload: dropboxUpload,
    postToAirTable: postToAirTable,
  },

  beforeMount() {
    this.model.productCategories = this.$utils.deepClone(productCategoryList);
  },
};

function onFileChange(event) {
  var files = event.target.files;

  if (files[0].size > 15485760) {
    this.$swal("Alert", "File cannot be larger than 25mb");
    return;
  }

  this.model.fileUploaded = true;
  this.model.file = files[0];
  this.model.uploadedFileName = files[0].name;
}

function removeFile() {
  this.model.fileUploaded = false;
  this.model.file = false;
  this.model.uploadedFileName = "";
}

function submit() {
  this.model.fileUploaded = this.model.file ? true : false;
  this.$validator.validate().then((valid) => {
    if (!valid || !this.model.fileUploaded) {
      return false;
    } else {
      this.dropboxUpload();
    }
  });
}

function dropboxUpload() {
  if (this.requestStarted) {
    return;
  }

  this.requestStarted = true;

  let app = this,
    ACCESS_TOKEN = "ZAVLWjhidyAAAAAAAABimxSEDyMZZy7qzBBBD2QRDjK5x2b63xss3mOyZ8wCc7m0",
    dbx = new Dropbox({ accessToken: ACCESS_TOKEN }),
    fileExtension = app.model.file.type.split("/")[1];

  dbx
    .filesUpload({
      path:
        "/" + "Assortment_" + app.model.firstName + "_" + app.model.lastName + "_" + Date.now() + "." + fileExtension,
      contents: app.model.file,
    })
    .then(function (response) {
      let dropBoxCVUrl = "https://www.dropbox.com/home/Apps/Bulletin%20Assortments" + response.path_lower;
      app.postToAirTable(dropBoxCVUrl);
    })
    .catch(function (error) {
      this.requestStarted = false;
      this.$swal("Alert", "Something went wrong. Please try again later");
    });
}

function postToAirTable(dropBoxCVUrl) {
  this.model.url = dropBoxCVUrl;
  (this.model.productCategory = this.model.productCategories[this.model.productCategory - 1].category_name),
    FormApiService.requestAssortment(this.model)
      .then((response) => {
        this.requestStarted = false;
        this.resetForm();
        this.$swal("Success", "Your application was successfully submitted! :)");
      })
      .catch((error) => {
        this.requestStarted = false;
        this.$swal("Alert", "Something went wrong. Please try again later");
      });
}

function resetForm() {
  (this.model.fileUploaded = true), (this.model.uploadedFileName = ""), (this.model.file = false);
  (this.model.firstName = ""),
    (this.model.lastName = ""),
    (this.model.brandName = ""),
    (this.model.instagram = ""),
    (this.model.emailAddress = ""),
    (this.model.phoneNumber = ""),
    (this.model.website = ""),
    (this.model.productCategory = ""),
    (this.model.hearAboutBulletin = ""),
    (this.model.sellStores = ""),
    this.$validator.reset();
}
